import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import storeConfig from "./storeConfig";

import { reducer as storeReducer } from "./store";
import { reducer as authReducer } from "./auth";

export default () => {
  const appReducer = combineReducers({
    store: storeReducer,
    auth: authReducer,
  });

  return storeConfig(appReducer, function* rootSaga() {
    yield all([]);
  });
};
